"use client";
import { Suspense } from "react";
import "../globals.css";
// export const metadata = {
//   title: 'Next.js',
//   description: 'Generated by Next.js',
// }
import { AppContextProvider } from "@/contexts/AppContext";

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <AppContextProvider>
        <html lang="en">
          <body>{children}</body>
        </html>
      </AppContextProvider>
    </Suspense>
  );
}
